import { render } from "./OrganizationSidepanel.vue?vue&type=template&id=2bc76fe8&scoped=true"
import script from "./OrganizationSidepanel.vue?vue&type=script&lang=js"
export * from "./OrganizationSidepanel.vue?vue&type=script&lang=js"

import "./OrganizationSidepanel.vue?vue&type=style&index=0&id=2bc76fe8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc76fe8"]])

export default __exports__